// extracted by mini-css-extract-plugin
export default {"container":"UploadNFT_container__U9j6y","subContainer":"UploadNFT_subContainer__xqLNR","leftArrow":"UploadNFT_leftArrow__Tp3BF"};